import type { Action } from "./types";

const browseTier: Action<"browseTier"> = (state, msg) => {
  const ids = state.tiers.map((tier) => tier.id);
  const index = ids.indexOf(state.selectedTier ?? state.currentTier ?? "");
  const next = ids[index + (msg.direction === "next" ? 1 : -1)];

  if (index === -1 || !next) return state;

  return { ...state, selectedTier: next };
};

export default browseTier;
